import { DeliveryMode } from '../../../../../../services/exports/Constants';

export default {
  types: {
    circle: 'Cerc',
    polygon: 'Poligon',
    zip: 'Cod poștal',
  },
  fields: {
    name: {
      label: 'Nume',
    },
    color: {
      label: 'Culoare',
    },
    min_threshold: {
      label: 'Valoare minimă comandă',
    },
    max_threshold: {
      label: 'Valoare maximă comandă',
    },
    fee: {
      [DeliveryMode.Internal]: {
        label: 'Taxă de livrare',
      },
      [DeliveryMode.External]: {
        label: 'Taxă plătită de restaurant',
      },
    },
    zip_codes: {
      label: 'Coduri poștale (fiecare pe un rând nou)',
    },
  },
  labels: {
    hidden: '(ascuns)',
  },
  buttons: {
    save: 'Salvează',
    cancel_changes: 'Anulează modificările',
    add_max_order_amount: 'Adăugați valoare maximă comandă',
  },
  modals: {
    delete_confirmation: {
      title: 'Sigur doriți să ștergeți {{name}}',
    },
  },
  toasts: {
    failed_to_save_changes: 'Salvarea modificărilor pentru {{name}} a eșuat',
    delivery_zone_got_updated: 'Modificările pentru {{name}} au fost salvate cu succes',
    failed_to_delete_delivery_zone: 'Ștergerea {{name}} a eșuat',
    delivery_zone_got_deleted: '{{name}} a fost șters cu succes',
  },
};
